export default __webpack_public_path__ + "static/media/Precos_das_Filmagens_em_Equipamentos_Publicos.896ea36a.pdf";